import { styled } from '../../Utilities';
import { SwatchColorPickerBase } from './SwatchColorPicker.base';
import { getStyles } from './SwatchColorPicker.styles';
export var SwatchColorPicker = styled(SwatchColorPickerBase, getStyles, undefined, { scope: 'SwatchColorPicker' });
//# sourceMappingURL=SwatchColorPicker.js.map